/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import DefaultOption from '../../components/defaultOption';
import s from './index.module.scss';
import multiOption from '../styles/multiOption.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import questionsMethods from '../../survey/questions';

function DefaultQuestion(props) {
  const { T } = useT();
  const { options, name } = props.step;
  const { withoutDescription } = props;
  const isExpandedDesign = props.isExpandedDesign ? multiOption.designExpanded : '';
  const isExpandedDesignImg = props.isExpandedDesign ? multiOption.expandedImg : '';
  const age = questionsMethods.getAnswers({ questionName: 'age' }).value;

  return (
    <section className={`${common.step}`}>
      <div className={common.stepTitle}>{T(name)}</div>
      {!withoutDescription && <div className={common.stepDescription}>{T(`${name}_description`)}</div>}
      <div className={s.options}>
        {
          options && Object.entries(options).map((option) => {
            let imgSrc;
            if (optionsImages[name]) imgSrc = (age && age !== 'female' && optionsImages[name][age]) ? optionsImages[name][age][option[1].value] : optionsImages[name][option[1].value];
            const withDescription = option[1].description;
            const isExpandedDesignStyle = isExpandedDesign && isExpandedDesignImg ? multiOption.withImg : '';

            return (
              <DefaultOption
                key={option[1].value}
                className={`${multiOption.option} ${isExpandedDesign} ${isExpandedDesignStyle}`}
                selectedStateClass={multiOption.optionSelected}
                option={option[1]}
                questionName={name}
                disableFromFocus={!props.isThisCurrentStep}
                resetIfValueSelected={props.resetIfValueSelected}
              >
                {imgSrc && <img className={`${multiOption.icon} ${isExpandedDesignImg}`} src={imgSrc} alt="" />}
                {!withDescription && T(`${name}_${option[1].value}`)}
                {withDescription
                  && (
                  <div>
                    <div className={`${option[1].design === 'smallTitleWithDescription' ? '' : s.title}`}>{T(`${name}_${option[1].value}`)}</div>
                    <div className={s.description}>{T(`${name}_${option[1].description}`)}</div>
                  </div>
                  )}
                <div className={multiOption.checkbox} />
              </DefaultOption>
            );
          })
        }
      </div>
    </section>
  );
}

function MultiOptions(props) {
  const questions = useSelector((state) => state.questions.list);
  const questionName = props.stepData.name;
  const question = questions[questionName];
  const { isThisCurrentStep } = props;
  const { isCurrentStepCompleted } = props;
  const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
  const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
  const { resetIfValueSelected } = props;
  const config = useSelector((state) => state.steps.config);
  const withoutDescription = config === 'short';

  return (
    <div className={`${s.step} ${isThisCurrentStepClass} ${isThisStepCompletedClass}`}>
      <DefaultQuestion
        step={question}
        index={1}
        isThisCurrentStep={isThisCurrentStep}
        isExpandedDesign={props.designExpanded}
        resetIfValueSelected={resetIfValueSelected}
        withoutDescription={withoutDescription}
      />
    </div>
  );
}

export default MultiOptions;
